export const getActiveFreeBets = (freeBet) => {
  return freeBet
    ?.filter((item) => {
      const endTimeStr = item?.Instances?.[0]?.end_time
      if (!endTimeStr) return true // Include spins without end_time
      const endTime = new Date(endTimeStr).getTime()
      return (
        endTime > new Date().getTime() &&
        item.Status.toLowerCase() !== 'claimed'
      )
    })
    .sort((a, b) => {
      const createdAtA = new Date(a?.CreatedAt).getTime()
      const createdAtB = new Date(b?.CreatedAt).getTime()
      return createdAtB - createdAtA
    })
}
